import { HistoryMain } from './components';

const ShippingRulePresetsHistory = () => <HistoryMain />;

export default ShippingRulePresetsHistory;
